// extracted by mini-css-extract-plugin
export default {"output":"CodeMirrorWrapper_output__fikxo","commands":"CodeMirrorWrapper_commands__9S4hN","command":"CodeMirrorWrapper_command__-xXCO"};